import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';

class JobKeyword extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillUnmount() {
    this.props.updateJobKeywords('');
  }
  render() {
    return(
      <div className="input-group" style={{zIndex:1}}>
        <input onChange={e => {
          this.props.updateJobKeywords(e.target.value);
          this.props.fetchJobs();
        }} className="form-control" placeholder="Enter a Client's Name" type="text" value={this.props.keywords} />
        <span className="input-group-addon"><i className="fa fa-search"></i></span>
      </div>
    );
  }
}

const mapStateToProps = ({ jobs }) => ({...jobs});

export default connect(mapStateToProps, Actions)(JobKeyword);



// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-keyword.js